const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/email/send-config/template.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { EmailSendConfigTplBodyFilterParamSchema } from '@apps/main/features/admin/pages/email/send-config-tpl-body-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/email/send-config/template')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: EmailSendConfigTplBodyFilterParamSchema
});